import React from "react";
import { Link } from "react-router-dom";
import EventBus from "../../../controllers/EventBus";
import Util from "../../../utils/Util";
import MyComponent from "../../custom/MyComponent";
import FormParametroValor from "../../../pages/ParametroValor/FormParametroValor";
import Permissao from "../../../controllers/Permissao";

export default class CrudList extends MyComponent {

    constructor(props) {
        super(props);

        this.getState = this.getState.bind(this);
        this.handleClickExpand = this.handleClickExpand.bind(this);
        this.handleClickExcluir = this.handleClickExcluir.bind(this);
        this.handleClickParametroValor = this.handleClickParametroValor.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDoubleClick = this.handleDoubleClick.bind(this);

        this.getData = this.getData.bind(this);
        this.onClear = this.onClear.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onList = this.onList.bind(this);

        this.state = this.getState(props);
        this.state.crud = {};
        this.state.container = true;
    }

    componentDidMount() {
        super.componentDidMount();
        if (!this.state.crud.searchFormSubmit) {
            this.onList();
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    onList() {
        if (this.state.crud?.service?.list) {
            this.state.crud.service.list((response) => {
                this.setState({ data: response });
            });
        }
    }

    onDelete(item) {
        if (this.state.crud?.service?.delete) {
            this.state.crud.service.delete(item.id, (response) => {
                this.onList();
            });
        }
    }

    getState(props) {
        return {
            data: [],
            model: {
                busca: ""
            },
            expand: true
        };
    }

    onClear() {
        this.setState(this.getState());
        if (!this.state.crud.searchFormSubmit) {
            this.onList();
        }
    }

    handleClickExcluir(item) {
        EventBus.dispatch("modal-confirmacao-open", {
            id: item[this.state.crud.keyItem],
            config: {
                title: "Excluir item?",
                message: <>Deseja realmente excluir o item: <strong>{item[this.state.crud.keyItem]} </strong>?</>,
                btnConfirmText: "Sim, excluir o item selecionado",
                description: "Esta é uma ação é irreversível!",
                style: "danger",
                confirm: this.onDelete
            }
        });
    }

    handleClickParametroValor(idModulo, cdChave) {
        EventBus.dispatch("modal-add", {
            title: 'Registro de Parâmetro',
            sizeModal: 'modal-lg',
            config: {
                isModal: true,
                idModulo: idModulo,
                cdChave: cdChave
            },
            form: FormParametroValor,
            onClose: () => {

            },
            onSave: () => {
                this.onList();
            }
        });
    }

    handleClickExpand() {
        this.setState({ expand: !this.state.expand })
    }

    getData() {
        if (this.state.crud.searchFormSubmit) {
            return this.state.data;
        } else {
            return this.state.data.filter(f =>
                Util.searchTextInObject(f, this.state.crud.itensFilter, this.state.model.busca)
            );
        }
    }

    onSubmit(event) {
        this.onList();
    }

    getButtonEdit(item) {
        return (
            <Link to={`${this.state.crud.urlForm}/${item[this.state.crud.keyItem]}`} className="btn btn-outline-primary btn-sm" title="Editar item">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                </svg>
            </Link>
        );
    }

    getButtonDelete(item) {
        return (
            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => { this.handleClickExcluir(item) }} title="Excluir item">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                </svg>
            </button>
        );
    }

    getButtonParametro(item) {
        var idModuloParametroValor = this.state.crud?.idModuloParametroValor;
        if (Permissao.getInstance().getPermissao(68) && idModuloParametroValor) {
            return (
                <button type="button" className="btn btn-sm btn-outline-dark" onClick={() => { this.handleClickParametroValor(idModuloParametroValor, item[this.state.crud.keyItem]) }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-circle-dotted" viewBox="0 0 16 16">
                        <path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                    </svg>
                </button>
            );
        }
        return <></>;
    }

    getButtons(item) {
        return (<>
            {this.getButtonEdit(item)}
            {this.getButtonDelete(item)}
            {this.getButtonParametro(item)}
        </>);
    }

    handleDoubleClick(e, item){
        if(this.props?.navigate && this.state?.crud?.urlForm && this.state?.crud?.keyItem && item[this.state.crud.keyItem]){
            this.props.navigate(this.state.crud.urlForm + '/' + item[this.state.crud.keyItem]);
            return true;
        }
        return false;
    }

    getFormFilter() {
        return (this.state.crud.searchFormSubmit ?

            <form onSubmit={this.handleSubmit} noValidate className={`needs-validation ${this.state.validated ? "was-validated" : ""}`} >
                <div className="row gap-2 mb-3">
                    <div className="col">
                        <div className="col-md-12 input-group mb-3">
                            <span className="input-group-text" id="addon-wrapping">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                            </span>
                            <input type="text" className="form-control" autoFocus autoComplete="off" name="busca" required="required" placeholder="Digite sua busca" value={this.state.model.busca} onChange={this.handleChange} minLength={3} />
                            <button className="btn btn-outline-primary" type="submit"> Buscar </button>
                        </div>
                    </div>
                    <div className="col-md-auto text-end d-grid d-md-block">
                        <button type="button" className="btn btn-outline-danger" onClick={this.onClear}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z" />
                                <path fillRule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z" />
                            </svg> Limpar Busca
                        </button>
                    </div>
                </div>
            </form>
            :
            <div className="row gap-2 mb-3">
                <div className="col">
                    <div className="input-group">
                        <span className="input-group-text" id="addon-wrapping">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                            </svg>
                        </span>
                        <input type="text" className="form-control" autoComplete="off" name="busca" required="required" placeholder="Busca" value={this.state.model.busca} onChange={this.handleChange} />
                    </div>
                </div>
                <div className="col-md-auto text-end d-grid d-md-block">
                    <button type="button" className="btn btn-outline-danger" onClick={this.onClear}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z" />
                            <path fillRule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z" />
                        </svg> Limpar Busca
                    </button>
                </div>
            </div>);
    }

    render() {
        return (
            <div className={`p-3 my-2 ${this.state.container ? 'container' : ''}`}>

                <div className="w-100">

                    <div className={`${this.state.expand ? '' : 'd-none'}`}>

                        <div className="hstack gap-3 mb-3">
                            <h4 className="mb-3 w-100">
                                {this.state.crud.labels.title}
                            </h4>
                            {this.state.crud.labels?.btnNewRegister !== undefined ?
                                <Link to={this.state.crud.urlForm} className="btn btn-outline-primary text-nowrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
                                    </svg> {this.state.crud.labels.btnNewRegister}
                                </Link>
                                : <></>}
                        </div>

                        {this.getFormFilter()}

                    </div>

                    <div className="table-responsive-sm">
                        <table className="table table-sm table-hover caption-top">
                            <caption className="text-end me-3">
                                {this.getData().length} Registro(s)

                                <button type="button" className="btn btn-link ms-2" onClick={this.handleClickExpand}>
                                    {this.state.expand ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-funnel-fill" viewBox="0 0 16 16">
                                            <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z" />
                                        </svg> :

                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-funnel" viewBox="0 0 16 16">
                                            <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z" />
                                        </svg>
                                    }
                                </button>

                            </caption>
                            <thead>
                                <tr>
                                    {this.getRenderHeader()}
                                    <th> &nbsp; </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.getData().map((item, index) => (
                                    <tr key={index} onDoubleClick={e => this.handleDoubleClick(e, item)}>
                                        {this.getRenderItem(item, index)}
                                        <td className="text-end d-flex flex-nowrap gap-2">
                                            {this.getButtons(item)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}